import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '../lib/api';

// Preserves the exact URL (path + query + hash) a logged-out visitor was
// trying to reach — including an invite token like
// `/attivita/<id>?invito=<code>` — so Auth.jsx can send them back there
// after a successful login or sign-up.
const REDIRECT_KEY = 'wallweek_post_login_redirect';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  if (!getToken()) {
    try {
      const full = `${location.pathname}${location.search || ''}${location.hash || ''}`;
      if (full && full !== '/' && full !== '/auth') {
        sessionStorage.setItem(REDIRECT_KEY, full);
      }
    } catch { /* storage unavailable — fall back to '/' */ }
    return <Navigate to="/auth" replace />;
  }
  try {
    const full = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    if (sessionStorage.getItem(REDIRECT_KEY) === full) sessionStorage.removeItem(REDIRECT_KEY);
  } catch { /* noop */ }
  return children;
};

export default ProtectedRoute;
